(function(){

  /* ============================================
     ALLEGORY INK â PREMIUM SEARCH EXPERIENCE
     ============================================ */

  /* === PAGE REDIRECTS === */
  var redirects = {
    'sponsor': {url: '/pages/sponsorship', label: 'Sponsorship Program', desc: 'Join our roster of world-class artists'},
    'sponsored': {url: '/pages/sponsorship', label: 'Sponsorship Program', desc: 'Join our roster of world-class artists'},
    'sponsorship': {url: '/pages/sponsorship', label: 'Sponsorship Program', desc: 'Join our roster of world-class artists'},
    'sponsored artist': {url: '/pages/sponsorship', label: 'Sponsorship Program', desc: 'Join our roster of world-class artists'},
    'sponsor kit': {url: '/pages/sponsorship', label: 'Sponsorship Program', desc: 'Join our roster of world-class artists'},
    'sponsor box': {url: '/pages/sponsorship', label: 'Sponsorship Program', desc: 'Join our roster of world-class artists'},
    'pro team': {url: '/pages/sponsorship', label: 'Sponsorship Program', desc: 'Join our roster of world-class artists'},
    'sponcer': {url: '/pages/sponsorship', label: 'Sponsorship Program', desc: 'Join our roster of world-class artists'},
    'apparel': {url: '/collections/apparel', label: 'Apparel', desc: 'Hats, beanies, merch & more'},
    'clothes': {url: '/collections/apparel', label: 'Apparel', desc: 'Hats, beanies, merch & more'},
    'clothing': {url: '/collections/apparel', label: 'Apparel', desc: 'Hats, beanies, merch & more'},
    'hoodie': {url: '/collections/apparel', label: 'Apparel', desc: 'Hats, beanies, merch & more'},
    'hat': {url: '/collections/apparel', label: 'Apparel', desc: 'Hats, beanies, merch & more'},
    'hats': {url: '/collections/apparel', label: 'Apparel', desc: 'Hats, beanies, merch & more'},
    'beanie': {url: '/collections/apparel', label: 'Apparel', desc: 'Hats, beanies, merch & more'},
    'faq': {url: '/pages/faq', label: 'FAQ', desc: 'Frequently asked questions'},
    'contact': {url: '/pages/contact-us', label: 'Contact Us', desc: 'Get in touch with our team'},
    'wholesale': {url: '/pages/wholesale-signup', label: 'Wholesale', desc: 'Partner with Allegory Ink'},
    'blaklist': {url: '/pages/blaklist', label: 'The Blaklist', desc: '120+ sponsored artists worldwide'},
    'artists': {url: '/pages/blaklist', label: 'The Blaklist', desc: '120+ sponsored artists worldwide'},
    'sds': {url: '/pages/safety-data-sheets', label: 'Safety Data Sheets', desc: 'SDS & compliance documents'},
    'msds': {url: '/pages/safety-data-sheets', label: 'Safety Data Sheets', desc: 'SDS & compliance documents'},
    'safety data': {url: '/pages/safety-data-sheets', label: 'Safety Data Sheets', desc: 'SDS & compliance documents'}
  };

  /* === QUICK SEARCH CATEGORIES === */
  var quickCategories = [
    {label: 'Black Inks', query: 'black'},
    {label: 'White Ink', query: 'white'},
    //{label: 'Grey Wash', query: 'grey wash'},
    {label: 'Grey Wash', url: '/search?type=product&options%5Bprefix%5D=last&q=grey'},
    {label: 'Bundles', query: 'bundle'},
    {label: 'Apparel', url: '/collections/apparel'},
    {label: 'Blaklist', url: '/pages/blaklist'},
    {label: 'Sponsorship', url: '/pages/sponsorship'}
  ];

  /* === ARTIST DATA === */
  var artists = null;
  var artistsLoading = false;

  function loadArtists() {
    if (artists || artistsLoading) return;
    artistsLoading = true;
    fetch('/cdn/shop/t/22/assets/artists.json?v=' + Date.now())
      .then(function(r) { return r.text(); })
      .then(function(text) {
        try {
          var data = JSON.parse(text);
          artists = Array.isArray(data) ? data : JSON.parse(data);
        } catch(e) { artists = []; }
      }).catch(function() { artists = []; });
  }

  function searchArtists(query) {
    if (!artists) return [];
    var q = query.toLowerCase();
    var matches = [];
    for (var i = 0; i < artists.length; i++) {
      var a = artists[i];
      if (a.name && a.name.toLowerCase().indexOf(q) !== -1) {
        matches.push(a);
        if (matches.length >= 3) break;
      }
    }
    return matches;
  }

  /* === REDIRECT MATCHING === */
  function checkRedirect(query) {
    var q = query.trim().toLowerCase();
    if (redirects[q]) return redirects[q];
    for (var key in redirects) {
      if (q.length >= 3 && (q.indexOf(key) === 0 || key.indexOf(q) === 0)) {
        return redirects[key];
      }
    }
    return null;
  }

  /* === INJECT PREMIUM STYLES === */
  var styleInjected = false;
  function injectStyles() {
    if (styleInjected) return;
    styleInjected = true;
    var css = document.createElement('style');
    css.id = 'sr-premium-styles';
    css.textContent = [

      /* --- SEARCH MODAL POLISH --- */

      /* Tighten modal padding */
      '.minisearch-popup .search-popup-wrap {',
      '  padding: 48px 0 24px !important;',
      '}',

      /* Heading â Bebas Neue, white */
      '.minisearch-popup .search-label {',
      '  font-family: "Bebas Neue", var(--alt-font), sans-serif !important;',
      '  font-weight: 400 !important;',
      '  font-size: clamp(24px, 3.5vw, 42px) !important;',
      '  letter-spacing: 0.08em !important;',
      '  text-transform: uppercase !important;',
      '  margin-bottom: 20px !important;',
      '  color: #ffffff !important;',
      '  opacity: 0.85;',
      '}',

      /* Search input */
      '.header-layout-style-1 .minisearch-popup .search-form-wrapper input[type=text] {',
      '  font-family: Urbanist, sans-serif !important;',
      '  font-size: 16px !important;',
      '  font-weight: 400 !important;',
      '  padding: 14px 48px 14px 24px !important;',
      '  border-radius: 60px !important;',
      '  transition: border-color 0.3s, box-shadow 0.3s !important;',
      '}',
      '.header-layout-style-1 .minisearch-popup .search-form-wrapper input[type=text]:focus {',
      '  border-color: #C62222 !important;',
      '  box-shadow: 0 0 0 3px rgba(198,34,34,0.15) !important;',
      '  outline: none !important;',
      '}',

      /* Overlay backdrop blur */
      '.active-search .search-overlay {',
      '  backdrop-filter: blur(12px) !important;',
      '  -webkit-backdrop-filter: blur(12px) !important;',
      '}',

      /* Close button */
      '.minisearch-popup .search-close {',
      '  transition: opacity 0.2s !important;',
      '  opacity: 0.4;',
      '}',
      '.minisearch-popup .search-close:hover { opacity: 1 !important; }',

      /* Hide theme quick search â we replace it */
      '.search-results-wrapper .quick-search { display: none !important; }',

      /* Results wrapper spacing */
      '.header-layout-style-1 .search-results-wrapper {',
      '  padding: 16px 80px 0 !important;',
      '}',

      /* Popular products label */
      '.search-results-wrapper .predictive-search > p {',
      '  font-family: Urbanist, sans-serif !important;',
      '  font-size: 10px !important;',
      '  font-weight: 700 !important;',
      '  text-transform: uppercase !important;',
      '  letter-spacing: 2px !important;',
      '  opacity: 0.35;',
      '  margin-bottom: 12px !important;',
      '}',

      /* Product cards in predictive */
      '.search-results-wrapper .details {',
      '  font-family: Urbanist, sans-serif !important;',
      '  font-size: 12px !important;',
      '  font-weight: 500 !important;',
      '  padding-top: 10px !important;',
      '  color: rgba(255,255,255,0.85) !important;',
      '}',
      '.search-results-wrapper .details span.price {',
      '  color: rgba(255,255,255,0.5) !important;',
      '}',
      '.search-results-wrapper img {',
      '  border-radius: 10px !important;',
      '  border: 1px solid rgba(255,255,255,0.06) !important;',
      '  transition: transform 0.3s ease, border-color 0.3s !important;',
      '}',
      '.search-results-wrapper a:hover img {',
      '  transform: scale(1.04);',
      '  border-color: rgba(198,34,34,0.25) !important;',
      '}',

      /* View All button */
      '.more-action .btn-black {',
      '  background: transparent !important;',
      '  color: #C62222 !important;',
      '  border: 1px solid rgba(198,34,34,0.4) !important;',
      '  border-radius: 30px !important;',
      '  font-family: Urbanist, sans-serif !important;',
      '  font-weight: 600 !important;',
      '  font-size: 12px !important;',
      '  letter-spacing: 1px !important;',
      '  text-transform: uppercase !important;',
      '  padding: 10px 32px !important;',
      '  transition: all 0.25s !important;',
      '}',
      '.more-action .btn-black:hover {',
      '  background: #C62222 !important;',
      '  color: #fff !important;',
      '  border-color: #C62222 !important;',
      '}',

      /* No result */
      '.no-search-result, .no-search-result a {',
      '  font-family: Urbanist, sans-serif !important;',
      '  opacity: 0.4;',
      '}',

      /* --- CUSTOM SUGGESTIONS --- */
      '#sr-custom-suggestions {',
      '  position: relative;',
      '  z-index: 9999;',
      '  padding: 0 0 4px;',
      '  max-width: 560px;',
      '  margin: 12px auto 0;',
      '  flex-shrink: 0;',
      '}',

      '.sr-section-label {',
      '  padding: 14px 8px 6px;',
      '  font-family: Urbanist, sans-serif;',
      '  font-size: 10px;',
      '  font-weight: 700;',
      '  opacity: 0.3;',
      '  text-transform: uppercase;',
      '  letter-spacing: 2px;',
      '}',

      '.sr-suggestion {',
      '  display: flex !important;',
      '  align-items: center;',
      '  gap: 14px;',
      '  padding: 10px 12px;',
      '  margin: 2px 0;',
      '  text-decoration: none !important;',
      '  border-radius: 12px;',
      '  transition: background 0.2s;',
      '  cursor: pointer;',
      '}',
      '.sr-suggestion:hover { background: rgba(255,255,255,0.05); }',

      '.sr-icon {',
      '  width: 42px; height: 42px;',
      '  border-radius: 10px;',
      '  display: flex; align-items: center; justify-content: center;',
      '  flex-shrink: 0; overflow: hidden;',
      '  background: rgba(255,255,255,0.05);',
      '}',
      '.sr-icon-round { border-radius: 50%; }',
      '.sr-icon img { width: 100%; height: 100%; object-fit: cover; }',

      '.sr-info { display: flex; flex-direction: column; min-width: 0; }',
      '.sr-name {',
      '  font-family: Urbanist, sans-serif;',
      '  font-size: 14px; font-weight: 600;',
      '  color: rgba(255,255,255,0.9);',
      '  line-height: 1.3;',
      '}',
      '.sr-meta {',
      '  font-family: Urbanist, sans-serif;',
      '  font-size: 12px;',
      '  color: rgba(255,255,255,0.35);',
      '  margin-top: 1px; line-height: 1.3;',
      '}',

      '.sr-arrow {',
      '  margin-left: auto; flex-shrink: 0;',
      '  opacity: 0; transform: translateX(-4px);',
      '  transition: opacity 0.2s, transform 0.2s;',
      '}',
      '.sr-suggestion:hover .sr-arrow {',
      '  opacity: 0.5; transform: translateX(0);',
      '}',

      '.sr-divider { height: 1px; background: rgba(255,255,255,0.06); margin: 6px 12px; }',

      /* Quick search pills â single line, scrollable */
      '#sr-quick-categories {',
      '  display: flex !important; align-items: center;',
      '  gap: 8px; justify-content: center;',
      '  padding: 0 20px;',
      '  margin: 16px auto 0;',
      '  max-width: 600px;',
      '  flex-wrap: nowrap;',
      '  overflow-x: auto;',
      '  -webkit-overflow-scrolling: touch;',
      '  scrollbar-width: none;',
      '  -ms-overflow-style: none;',
      '  min-height: 32px;',
      '  flex-shrink: 0;',
      '}',
      '#sr-quick-categories::-webkit-scrollbar { display: none; }',
      '#sr-quick-categories .sr-cat-label {',
      '  font-family: Urbanist, sans-serif;',
      '  font-size: 10px; font-weight: 700;',
      '  text-transform: uppercase; letter-spacing: 2px;',
      '  opacity: 0.3; flex-shrink: 0;',
      '  padding-right: 4px;',
      '}',
      '#sr-quick-categories a {',
      '  font-family: Urbanist, sans-serif;',
      '  font-size: 12px; font-weight: 500;',
      '  color: rgba(255,255,255,0.5) !important;',
      '  text-decoration: none !important;',
      '  padding: 6px 16px;',
      '  border: 1px solid rgba(255,255,255,0.1);',
      '  border-radius: 20px;',
      '  transition: all 0.2s;',
      '  white-space: nowrap;',
      '  flex-shrink: 0;',
      '}',
      '#sr-quick-categories a:hover {',
      '  color: #fff !important;',
      '  border-color: #C62222 !important;',
      '  background: rgba(198,34,34,0.12);',
      '}',

      /* Staggered fade-in for suggestion cards */
      '@keyframes srSlideIn {',
      '  from { opacity: 0; transform: translateY(8px); }',
      '  to { opacity: 1; transform: translateY(0); }',
      '}',
      '.sr-suggestion {',
      '  animation: srSlideIn 0.3s ease-out both;',
      '}',
      '.sr-suggestion:nth-child(2) { animation-delay: 0.04s; }',
      '.sr-suggestion:nth-child(3) { animation-delay: 0.08s; }',
      '.sr-suggestion:nth-child(4) { animation-delay: 0.12s; }',
      '.sr-suggestion:nth-child(5) { animation-delay: 0.16s; }',

      /* Tablet */
      '@media (max-width: 991px) {',
      '  .minisearch-popup .search-popup-wrap { padding: 36px 0 20px !important; }',
      '  .header-layout-style-1 .minisearch-popup .search-popup-inner { width: 90% !important; }',
      '  .header-layout-style-1 .search-results-wrapper { padding: 14px 16px 0 !important; }',
      '  #sr-custom-suggestions { max-width: 100%; margin-top: 10px; }',
      '  #sr-quick-categories { padding: 0 4px; margin-top: 12px; gap: 6px; justify-content: flex-start; }',
      '  #sr-quick-categories a { font-size: 11px; padding: 5px 12px; }',
      '  .minisearch-popup .search-label { font-size: 26px !important; margin-bottom: 14px !important; }',
      '  .header-layout-style-1 .minisearch-popup .search-form-wrapper input[type=text] { font-size: 16px !important; padding: 12px 44px 12px 20px !important; }',
      '  .sr-suggestion { padding: 8px 8px; gap: 12px; }',
      '  .sr-icon { width: 38px; height: 38px; }',
      '  .sr-name { font-size: 13px; }',
      '  .sr-meta { font-size: 11px; }',
      '  .search-results-wrapper .predictive-search > p { margin-bottom: 10px !important; }',
      '  .search-results-wrapper img { border-radius: 8px !important; }',
      '}',
      /* Phone */
      '@media (max-width: 480px) {',
      '  .minisearch-popup .search-popup-wrap { padding: 28px 0 16px !important; }',
      '  .minisearch-popup .search-label { font-size: 22px !important; margin-bottom: 12px !important; }',
      '  .header-layout-style-1 .search-results-wrapper { padding: 12px 12px 0 !important; }',
      '  #sr-quick-categories { margin-top: 10px; }',
      '  #sr-quick-categories a { font-size: 10px; padding: 4px 10px; }',
      '}',

    ''].join('\n');
    document.head.appendChild(css);
  }

  /* === BUILD QUICK CATEGORIES === */
  function injectQuickCategories() {
    if (document.getElementById('sr-quick-categories')) return;
    var resultsWrapper = document.querySelector('.search-results-wrapper');
    if (!resultsWrapper) return;

    var container = document.createElement('div');
    container.id = 'sr-quick-categories';
    var html = '<span class="sr-cat-label">Explore:</span>';
    for (var i = 0; i < quickCategories.length; i++) {
      var cat = quickCategories[i];
      if (cat.url) {
        html += '<a href="' + cat.url + '">' + cat.label + '</a>';
      } else {
        html += '<a href="/search?q=' + encodeURIComponent(cat.query) + '">' + cat.label + '</a>';
      }
    }
    container.innerHTML = html;
    resultsWrapper.parentNode.insertBefore(container, resultsWrapper);
  }

  /* === BUILD SUGGESTION HTML === */
  function buildRedirectCard(match) {
    return '<a href="' + match.url + '" class="sr-suggestion">'
      + '<span class="sr-icon" style="background:rgba(198,34,34,0.12);">'
      + '<svg width="18" height="18" fill="none" stroke="#C62222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7"/></svg>'
      + '</span>'
      + '<span class="sr-info">'
      + '<span class="sr-name">' + match.label + '</span>'
      + '<span class="sr-meta">' + match.desc + '</span>'
      + '</span>'
      + '<span class="sr-arrow"><svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" viewBox="0 0 24 24"><path d="M9 18l6-6-6-6"/></svg></span>'
      + '</a>';
  }

  function buildArtistCard(a) {
    var imgUrl = a.img || 'https://allegory.ink/blaklist/' + a.slug + '/' + a.slug + '.jpg';
    var link = '/pages/blaklist-artist?name=' + a.slug;
    var style = a.style || 'Artist';
    var meta = style + (a.current ? '  \u00B7  ' + (a.currentFlag || '') + ' ' + a.current : '');
    return '<a href="' + link + '" class="sr-suggestion">'
      + '<span class="sr-icon sr-icon-round">'
      + '<img src="' + imgUrl + '" alt="' + a.name + '" onerror="this.style.display=\'none\';this.parentNode.style.background=\'rgba(198,34,34,0.12)\';this.parentNode.innerHTML=\'<svg width=18 height=18 fill=none stroke=#C62222 stroke-width=2 viewBox=\\\'0 0 24 24\\\'><path d=\\\'M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2\\\'/><circle cx=12 cy=7 r=4/></svg>\'">'
      + '</span>'
      + '<span class="sr-info">'
      + '<span class="sr-name">' + a.name + '</span>'
      + '<span class="sr-meta">' + meta + '</span>'
      + '</span>'
      + '<span class="sr-arrow"><svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" viewBox="0 0 24 24"><path d="M9 18l6-6-6-6"/></svg></span>'
      + '</a>';
  }

  /* === INJECT / UPDATE SUGGESTIONS === */
  function updateSuggestions(query) {
    injectStyles();
    var container = document.getElementById('sr-custom-suggestions');

    if (!query || query.trim().length < 2) {
      if (container) { container.innerHTML = ''; container.style.display = 'none'; }
      return;
    }

    var q = query.trim();
    var match = checkRedirect(q);
    var artistMatches = searchArtists(q);

    if (!match && artistMatches.length === 0) {
      if (container) { container.innerHTML = ''; container.style.display = 'none'; }
      return;
    }

    if (!container) {
      container = document.createElement('div');
      container.id = 'sr-custom-suggestions';
    }

    var html = '';

    if (match) {
      html += '<div class="sr-section-label">Pages</div>';
      html += buildRedirectCard(match);
    }

    if (match && artistMatches.length > 0) {
      html += '<div class="sr-divider"></div>';
    }

    if (artistMatches.length > 0) {
      html += '<div class="sr-section-label">Blaklist Artists</div>';
      for (var i = 0; i < artistMatches.length; i++) {
        html += buildArtistCard(artistMatches[i]);
      }
    }

    container.innerHTML = html;
    container.style.display = 'block';

    var resultsWrapper = document.querySelector('.search-results-wrapper');
    var quickCats = document.getElementById('sr-quick-categories');
    var insertBefore = quickCats || resultsWrapper;
    if (insertBefore && container.parentNode !== insertBefore.parentNode) {
      insertBefore.parentNode.insertBefore(container, insertBefore);
    } else if (insertBefore && !document.getElementById('sr-custom-suggestions')) {
      insertBefore.parentNode.insertBefore(container, insertBefore);
    }
  }

  /* === BIND EVENTS === */
  function bindSearch() {
    var form = document.getElementById('form-minisearch');
    if (!form || form.dataset.srBound === 'true') return;
    form.dataset.srBound = 'true';
    var input = form.querySelector('input[name="q"]');
    if (!input) return;

    loadArtists();
    injectQuickCategories();

    input.addEventListener('input', function() {
      updateSuggestions(input.value);
    });

    input.addEventListener('focus', function() {
      if (input.value.trim().length >= 2) updateSuggestions(input.value);
    });

    form.addEventListener('submit', function(e) {
      var match = checkRedirect(input.value);
      if (match) {
        e.preventDefault();
        window.location.href = match.url;
      }
    });
  }

  /* === INIT === */
  function boot() { injectStyles(); bindSearch(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  new MutationObserver(function() {
    bindSearch();
    injectQuickCategories();
    var input = document.querySelector('#form-minisearch input[name="q"]');
    if (input && input.value.trim().length >= 2 && !document.getElementById('sr-custom-suggestions')) {
      updateSuggestions(input.value);
    }
  }).observe(document.body, {childList: true, subtree: true});

  /* ============================================
     BLAKLIST ARTIST SEO â META TAGS + SCHEMA
     Runs on /pages/blaklist-artist?name=slug
     ============================================ */
  function initArtistSEO() {
    if (window.location.pathname.indexOf('blaklist-artist') === -1) return;
    var params = new URLSearchParams(window.location.search);
    var slug = params.get('name');
    if (!slug) return;

    /* Wait for artists data (reuse the loader) */
    function tryInject() {
      if (!artists || artists.length === 0) {
        /* artists.json not loaded yet, retry */
        setTimeout(tryInject, 200);
        return;
      }
      var artist = null;
      for (var i = 0; i < artists.length; i++) {
        if (artists[i].slug === slug) { artist = artists[i]; break; }
      }
      if (!artist) return;
      if (document.head.querySelector('#sr-seo-injected')) return;

      /* Build SEO strings */
      var bioSnippet = artist.bio && artist.bio.trim()
        ? artist.bio.substring(0, 140).replace(/\s+/g, ' ').trim() + '...'
        : artist.style + ' tattoo artist based in ' + artist.current + ', working at ' + artist.shop + '. Sponsored by Allegory Ink.';
      var seoTitle = artist.name + ' \u2014 ' + artist.style + ' Tattoo Artist | Allegory Ink';
      var seoDesc = 'Explore ' + artist.name + "'" + 's tattoo portfolio. ' + bioSnippet;
      var seoImg = artist.img;
      var seoUrl = 'https://allegoryink.com/pages/blaklist-artist?name=' + artist.slug;

      /* Update document title */
      document.title = seoTitle;

      /* Clean URL in address bar */
      if (window.location.pathname.indexOf('/artists/') === -1) {
        history.replaceState(null, '', '/artists/' + artist.slug);
      }

      /* Update / create meta tags */
      function setMeta(attr, val, content) {
        var el = document.querySelector('meta[' + attr + '="' + val + '"]');
        if (el) { el.setAttribute('content', content); }
        else {
          el = document.createElement('meta');
          el.setAttribute(attr, val);
          el.setAttribute('content', content);
          document.head.appendChild(el);
        }
      }
      setMeta('name', 'description', seoDesc);
      setMeta('property', 'og:title', seoTitle);
      setMeta('property', 'og:description', seoDesc);
      setMeta('property', 'og:image', seoImg);
      setMeta('property', 'og:url', seoUrl);
      setMeta('property', 'og:type', 'profile');
      setMeta('name', 'twitter:title', seoTitle);
      setMeta('name', 'twitter:description', seoDesc);
      setMeta('name', 'twitter:image', seoImg);
      setMeta('name', 'twitter:card', 'summary_large_image');

      /* Update canonical */
      var canon = document.querySelector('link[rel="canonical"]');
      if (canon) canon.setAttribute('href', seoUrl);

      /* Schema.org ProfilePage + Person */
      var schema = {
        '@context': 'https://schema.org',
        '@type': 'ProfilePage',
        'mainEntity': {
          '@type': 'Person',
          'name': artist.name,
          'description': seoDesc,
          'image': seoImg,
          'url': seoUrl,
          'jobTitle': 'Tattoo Artist',
          'knowsAbout': artist.style,
          'workLocation': {
            '@type': 'Place',
            'name': artist.shop,
            'address': {'@type': 'PostalAddress', 'addressCountry': artist.current}
          },
          'sameAs': [artist.instagram],
          'memberOf': {'@type': 'Organization', 'name': 'Allegory Ink', 'url': 'https://allegoryink.com'}
        }
      };
      var schemaEl = document.createElement('script');
      schemaEl.type = 'application/ld+json';
      schemaEl.id = 'sr-seo-injected';
      schemaEl.textContent = JSON.stringify(schema);
      document.head.appendChild(schemaEl);
    }

    loadArtists();
    tryInject();
  }

  /* Run artist SEO on page load */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initArtistSEO);
  } else {
    initArtistSEO();
  }

  /* ============================================
     BACK IN STOCK â SUBTLE NOTIFY CALLOUT
     Shows below variant selector when any variant is OOS
     ============================================ */
  function initBackInStock() {
    /* Only run on product pages */
    if (!document.querySelector('variant-radios') && !document.querySelector('variant-selects')) return;
    if (document.getElementById('sr-bis-callout')) return;

    /* Find variant data */
    var variantScript = document.querySelector('variant-radios script[type="application/json"], variant-selects script[type="application/json"]');
    if (!variantScript) return;

    var variants;
    try { variants = JSON.parse(variantScript.textContent); } catch(e) { return; }

    var totalVariants = variants.length;
    var oosVariants = variants.filter(function(v) { return !v.available; });
    if (oosVariants.length === 0) return;

    /* Determine messaging */
    var allOOS = oosVariants.length === totalVariants;
    var hasOptions = totalVariants > 1;

    /* Build callout */
    var callout = document.createElement('div');
    callout.id = 'sr-bis-callout';

    var message, subtext;
    if (allOOS) {
      message = 'This item is currently sold out';
      subtext = 'Get notified when it\u2019s back in stock';
    } else if (hasOptions) {
      var oosNames = oosVariants.map(function(v) { return v.public_title || v.title; });
      if (oosNames.length <= 3) {
        message = oosNames.join(', ') + (oosNames.length === 1 ? ' is' : ' are') + ' sold out';
      } else {
        message = oosNames.length + ' sizes are sold out';
      }
      subtext = 'Tap a sold out option to get notified';
    }

    callout.innerHTML = '<div class="sr-bis-inner">'
      + '<svg class="sr-bis-icon" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>'
      + '<span class="sr-bis-text">'
      + '<span class="sr-bis-msg">' + message + '</span>'
      + '<span class="sr-bis-msg">\u00B7</span>'
      + (allOOS ? '<a href="#" class="sr-bis-link">' + subtext + '</a>' : '<span class="sr-bis-sub">' + subtext + '</span>')
      + '</span>'
      + '</div>';

    /* Inject styles */
    if (!document.getElementById('sr-bis-styles')) {
      var style = document.createElement('style');
      style.id = 'sr-bis-styles';
      style.textContent = [
        '#sr-bis-callout {',
        '  margin: 16px 0 0;',
        '  animation: srBisFade 0.4s ease-out;',
        '}',
        '.sr-bis-inner {',
        '  display: inline-flex;',
        '  align-items: center;',
        '  gap: 8px;',
        '  padding: 0;',
        '  background: transparent;',
        '  border: none;',
        '}',
        '.sr-bis-icon {',
        '  color: #999;',
        '  flex-shrink: 0;',
        '}',
        '.sr-bis-text {',
        '  display: flex;',
        '  align-items: baseline;',
        '  gap: 6px;',
        '  flex-wrap: wrap;',
        '}',
        '.sr-bis-msg {',
        '  font-family: Urbanist, sans-serif;',
        '  font-size: 12px;',
        '  font-weight: 400;',
        '  color: #888;',
        '}',
        '.sr-bis-sub {',
        '  font-family: Urbanist, sans-serif;',
        '  font-size: 12px;',
        '  color: #999;',
        '  font-style: italic;',
        '}',
        '.sr-bis-link {',
        '  font-family: Urbanist, sans-serif;',
        '  font-size: 12px;',
        '  font-weight: 500;',
        '  color: #C62222 !important;',
        '  text-decoration: underline !important;',
        '  text-underline-offset: 2px;',
        '  transition: opacity 0.2s;',
        '}',
        '.sr-bis-link:hover { opacity: 0.7; }',
        /* Hide wishlist heart button */
        '.wishlist-btn { display: none !important; }',

        '@keyframes srBisFade {',
        '  from { opacity: 0; transform: translateY(-4px); }',
        '  to { opacity: 1; transform: translateY(0); }',
        '}',
        '@media (max-width: 768px) {',
        '  .sr-bis-inner { padding: 8px 12px; }',
        '  .sr-bis-msg { font-size: 11px; }',
        '  .sr-bis-sub { font-size: 10px; }',
        '}',
      ''].join('\n');
      document.head.appendChild(style);
    }

    /* Insert after the variant selector fieldset */
    var fieldset = document.querySelector('.product-filter.size-filter') || document.querySelector('.product-form__input');
    if (fieldset) {
      fieldset.parentNode.insertBefore(callout, fieldset.nextSibling);
    }

    /* If all OOS, clicking the link opens the notify popup */
    if (allOOS) {
      var link = callout.querySelector('.sr-bis-link');
      if (link) {
        link.addEventListener('click', function(e) {
          e.preventDefault();
          var notifyBtn = document.querySelector('.product-form__submit');
          if (notifyBtn) notifyBtn.click();
        });
      }
    }
  }

  /* Run back-in-stock on product pages */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBackInStock);
  } else {
    initBackInStock();
  }

})();
